import { add } from 'date-fns';
import { useTranslation } from 'react-i18next';

import { formatByLocale } from 'utils/date';

import { Box, Chip } from '@mui/material';

import { ChipSelection, SelectedChip } from '../../enum';

interface ChipsProps {
  isSetToMonth: boolean;
  selectedChip: string;
  onChipClick: (ChipType: SelectedChip) => void;
}

export default function Chips({
  isSetToMonth,
  selectedChip,
  onChipClick
}: ChipsProps) {
  const { t } = useTranslation();

  return (
    <Box display="flex" gap={2}>
      {isSetToMonth ? (
        <>
          <Chip
            variant={
              selectedChip === ChipSelection.UNTIL_LAST_MONTH
                ? 'filled'
                : 'outlined'
            }
            color="primary"
            onClick={() => onChipClick(ChipSelection.UNTIL_LAST_MONTH)}
            label={`${t('until')} ${formatByLocale(
              add(new Date(), {
                months: -1
              }),
              'MMMM'
            )}`}
          />
          <Chip
            variant={
              selectedChip === ChipSelection.LAST_MONTH ? 'filled' : 'outlined'
            }
            color="primary"
            onClick={() => onChipClick(ChipSelection.LAST_MONTH)}
            label={formatByLocale(
              add(new Date(), {
                months: -1
              }),
              'MMMM'
            )}
          />
          <Chip
            variant={
              selectedChip === ChipSelection.THIS_MONTH ? 'filled' : 'outlined'
            }
            color="primary"
            onClick={() => onChipClick(ChipSelection.THIS_MONTH)}
            label={formatByLocale(new Date(), 'MMMM')}
          />
          <Chip
            variant={
              selectedChip === ChipSelection.NEXT_MONTH ? 'filled' : 'outlined'
            }
            color="primary"
            onClick={() => onChipClick(ChipSelection.NEXT_MONTH)}
            label={formatByLocale(
              add(new Date(), {
                months: 1
              }),
              'MMMM'
            )}
          />
        </>
      ) : (
        <>
          <Chip
            variant={
              selectedChip === ChipSelection.UNTIL_LAST_WEEK
                ? 'filled'
                : 'outlined'
            }
            color="primary"
            onClick={() => onChipClick(ChipSelection.UNTIL_LAST_WEEK)}
            label={`${t('until')} ${t('week').toLowerCase()} ${formatByLocale(
              add(new Date(), {
                weeks: -1
              }),
              'ww'
            )}`}
          />
          <Chip
            variant={
              selectedChip === ChipSelection.LAST_WEEK ? 'filled' : 'outlined'
            }
            color="primary"
            onClick={() => onChipClick(ChipSelection.LAST_WEEK)}
            label={t('lastWeek')}
          />
          <Chip
            variant={
              selectedChip === ChipSelection.THIS_WEEK ? 'filled' : 'outlined'
            }
            color="primary"
            onClick={() => onChipClick(ChipSelection.THIS_WEEK)}
            label={t('thisWeek')}
          />
          <Chip
            variant={
              selectedChip === ChipSelection.NEXT_WEEK ? 'filled' : 'outlined'
            }
            color="primary"
            onClick={() => onChipClick(ChipSelection.NEXT_WEEK)}
            label={t('nextWeek')}
          />
        </>
      )}
      <Chip
        variant={selectedChip === ChipSelection.CUSTOM ? 'filled' : 'outlined'}
        color="primary"
        onClick={() => onChipClick(ChipSelection.CUSTOM)}
        label={t('custom')}
      />
    </Box>
  );
}
